import React from 'react';
import ReactDOM from 'react-dom/client';
import { setupInterceptors } from '@/api/interceptors';
import { AppProvider } from '@/app/providers/AppProvider';
import { MedicalApp } from '@/pages/medical/MedicalApp';
import '@/shared/styles/globals.css';

setupInterceptors();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider>
      <MedicalApp />
    </AppProvider>
  </React.StrictMode>,
);
